// SIRET lookup for the MLS tab of a client's admin page.
//
// Agency names and providers come back from MLS, i.e. from outside this app, so
// results are built with .text() rather than string-interpolated HTML.

const MIN_LENGTH = 8
const DEBOUNCE_MS = 400

let searchTimer = null
let lastQuery = null

function setState (message) {
  $('#mls-search-state').text(message || '')
}

// `required` is toggled with visibility rather than set in the markup: a hidden
// required input makes the browser refuse to submit with nothing focusable to
// point at. MLS demands all three to create an agency.
function showCreationFields (show) {
  $('#mls-agency-fields').toggleClass('d-none', !show)
  $('#mls-address, #mls-phone, #mls-mobile').prop('required', show)
}

// No match: clear the picked agency and reveal the creation fields.
function selectAgency (id) {
  $('#mls-agency-id').val(id)
  showCreationFields(!id)
}

function agencyRow (agency) {
  const providers = (agency.providers || []).map(function (p) { return p.name }).filter(Boolean)

  const details = []
  details.push(agency.active ? 'active' : 'inactive')
  if (agency.email) { details.push(agency.email) }
  if (providers.length) { details.push('logiciel : ' + providers.join(', ')) }

  const $body = $('<span></span>')
  $body.append($('<strong></strong>').text(agency.name || '(sans nom)'))
  $body.append($('<span class="text-muted ms-2"></span>').text(agency.registration_number || ''))
  $body.append($('<span class="text-muted small d-block"></span>').text(details.join(' · ')))

  const $radio = $('<input type="radio" class="form-check-input flex-shrink-0 mt-1 js-mls-agency-choice">')
    .attr('name', 'mls_agency_choice')
    .attr('value', agency.id)

  // The whole card is the label, so clicking anywhere picks the agency. Not a
  // .form-check: outside that wrapper Bootstrap leaves the input in flow, which
  // is what we want inside a flex row.
  return $('<label class="hover-trans d-flex gap-3 align-items-start border rounded p-3 mb-2"></label>')
    .append($radio, $body)
}

function renderResults (results) {
  const $container = $('#mls-agency-results').empty()

  if (!results.length) {
    setState('aucun résultat')
    selectAgency('')
    $container.append($('<p class="text-muted small mb-0"></p>').text('Aucune agence MLS pour ce numéro.'))
    return
  }

  setState(results.length + ' agence(s) trouvée(s)')
  $container.append($('<p class="small mb-2"></p>').text('Sélectionnez l\'agence à rattacher :'))
  results.forEach(function (agency) { $container.append(agencyRow(agency)) })

  // One hit is the normal case -- preselect it so the admin only confirms.
  if (results.length === 1) {
    $container.find('.js-mls-agency-choice').prop('checked', true)
    selectAgency(results[0].id)
  } else {
    selectAgency('')
  }
}

function search (registrationNumber) {
  setState('recherche…')

  $.ajax({
    url: $('#mls-siret').data('searchUrl'),
    data: { registration_number: registrationNumber },
    dataType: 'json'
  }).done(function (data) {
    renderResults(data.results || [])
  }).fail(function (xhr) {
    const message = (xhr.responseJSON && xhr.responseJSON.error) || 'La recherche MLS a échoué.'
    setState('')
    selectAgency('')
    $('#mls-agency-results').empty().append($('<div class="alert alert-danger mb-0"></div>').text(message))
  })
}

$(document).on('input', '#mls-siret', function () {
  const value = $(this).val().trim()

  clearTimeout(searchTimer)
  showCreationFields(false)

  // Too short to search yet: clear the pick, but don't claim "no agency found"
  // and don't mark the creation fields required -- no search has run.
  // selectAgency('') would do both, since it reveals the block whenever the id
  // is empty.
  if (value.length < MIN_LENGTH) {
    setState('')
    lastQuery = null
    $('#mls-agency-results').empty()
    $('#mls-agency-id').val('')
    return
  }

  if (value === lastQuery) { return }

  searchTimer = setTimeout(function () {
    lastQuery = value
    search(value)
  }, DEBOUNCE_MS)
})

$(document).on('change', '.js-mls-agency-choice', function () {
  selectAgency($(this).val())
})

// The SIRET is prefilled from the client's profile when we hold one, and the
// search only ever runs on input. Without this the admin sees a filled field
// that has searched for nothing, and the creation block -- where the prefilled
// licence number lives -- stays hidden.
$(function () {
  const siret = $('#mls-siret')
  if (siret.length && siret.val().trim().length >= MIN_LENGTH) { siret.trigger('input') }
})
